/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    modals: {
      commentFC: false,
      reminder: false,
      consent: false,
      scoreHistoryFC: false,
    },
  },
  reducers: {
    setModals: (
      state,
      { payload: { modals } }: PayloadAction<{ modals: any }>,
    ) => {
      const { commentFC, reminder, consent, scoreHistoryFC } = modals

      state.modals = {
        commentFC: commentFC ?? state.modals.commentFC,
        reminder: reminder ?? state.modals.reminder,
        consent: consent ?? state.modals.consent,
        scoreHistoryFC: scoreHistoryFC ?? state.modals.scoreHistoryFC,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = modalsSlice.getInitialState()
    })
  },
})

export const { setModals } = modalsSlice.actions

export default modalsSlice.reducer
